// extracted by css-extract-rspack-plugin
var _1 = "HGNGXSWNe4AqAH9R";
var _2 = "qQBRd6ZGUaAorQew";
var _3 = "UdbpNuYk8BOa9YKf";
var _4 = "g_0ZcuMHH9gMGCGc";
var _5 = "BuJKDKCnml8vQMBR";
var _6 = "RA2fuEMzeYYbMK1m";
var _7 = "oi1TeidtT1MOgs0q";
var _8 = "MijXILz9alEU_S4L";
var _9 = "VHa1NNnp_RkwyBzn";
var _a = "CXn4EGexYq07U4qr";
var _b = "kM3MveHm51kZtfxr";
export { _1 as "contentWrapPadding", _2 as "contentWrapPaddingFit", _3 as "contentWrapPaddingFullWidth", _4 as "contentWrapPaddingMedium", _5 as "contentWrapSpacious", _6 as "contentWrapSpaciousFullWidth", _7 as "headerPaddingDefault", _8 as "headerPaddingFit", _9 as "headerPaddingFitGray", _a as "headerPaddingMedium", _b as "headerPaddingSpacious" }
